import {useLocation} from 'react-router-dom';
import './footer.scss';

function Footer() {
  const location = useLocation();
  if (location.pathname !== '/') return <footer data-testid='footer'/>;

  const eNamadId = '486569';
  const eNamadCode = 'pCvUZ4jXR4eGcdErUpBtKBDHY0oCfX6H';

  return (
    <footer data-testid='footer'>
      <div>
        <div id='samandehi'></div>
        <div id='e-namad'>
          <a
            referrerPolicy='origin'
            target='_blank'
            href={`https://trustseal.enamad.ir/?id=${eNamadId}&Code=${eNamadCode}`}
          >
            <img
              id={eNamadCode}
              referrerPolicy='origin'
              src={`https://trustseal.enamad.ir/logo.aspx?id=${eNamadId}&Code=${eNamadCode}`}
              alt='e-namad'
            />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
